import { render, staticRenderFns } from "./OrderPlace.vue?vue&type=template&id=f64e8c72&scoped=true&"
import script from "./OrderPlace.vue?vue&type=script&lang=js&"
export * from "./OrderPlace.vue?vue&type=script&lang=js&"
import style0 from "./OrderPlace.vue?vue&type=style&index=0&id=f64e8c72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64e8c72",
  null
  
)

export default component.exports